import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {


    GetUsers(pageNo, pageSize, UserType, municipalitieId, hostpitalId) {
        return axios.get(`/Api/Admin/User/Get?pageNo=${pageNo}&pagesize=${pageSize}&userType=${UserType}&municipalitieId=${municipalitieId}&hostpitalId=${hostpitalId}`);
    },

    AddUser(bodyObject) {
        return axios.post('/Api/Admin/User/Add', bodyObject);
    },
    EditUser(bodyObject) {
        return axios.post('/Api/Admin/User/Edit', bodyObject);
    },

    ChangeStatusUser(Id) {
        return axios.post(`/Api/Admin/User/${Id}/ChangeStatus`);
    },

    DeleteUser(Id) {
        return axios.post(`/Api/Admin/User/${Id}/Delete`);
    },

    UploadImage(bodyObject) {
        return axios.post('/Api/Admin/User/UploadImage', bodyObject);
    },

    EditUsersProfile(bodyObject) {
        return axios.post('/Api/Admin/User/EditUsersProfile', bodyObject);
    },

    ChangePassword(userPassword) {
        return axios.post(`/Api/Admin/User/ChangePassword`, userPassword);
    },







    IsLoggedin() {
        return axios.get(`/Security/IsLoggedin`);
    },
    loginUser(OBJ) {
        return axios.post(`/Security/loginUser`, OBJ);
    },
    Logout() {
        return axios.post(`/Security/Logout`);
    },
    ChangePasswords(object) {
      
        return axios.post(`/Api/Admin/User/ChangePassword`, object);
    },

    // **********************************    Applications ***********************

    AddApplications(bodyObject) {
        return axios.post(`/Api/Admin/Applications/Add`, bodyObject);
    },

    EditApplications(bodyObject) {
        return axios.post(`/Api/Admin/Applications/Edit`, bodyObject);
    },

    GetApplications(pageNo, pageSize, MunicipalitId, SelectedHospitalsId) {
        return axios.get(`/Api/Admin/Applications/Get?pageno=${pageNo}&pagesize=${pageSize}&MunicipalitId=${MunicipalitId}&selectedHospitalsId=${SelectedHospitalsId}`);
    },

    deleteApp(id) {
        return axios.post(`/Api/Admin/Applications/${id}/delete`);
    },

    GetBranchesName(id) {
        return axios.get(`/Api/Admin/Applications/GetBranchesNames?cityId=${id}`);
    },

    GetBranchesAllName() {
        return axios.get(`/Api/Admin/Applications/GetAllBranchesNames`);
    },

    

    // **********************************    Hospitals ***********************

    GetHospitalsAllName(MunicipalitId) {
        return axios.get(`/Api/Admin/Hospitals/GetAllHospitalsNames?MunicipalitId=${MunicipalitId}`);
    },

    AddHospitals(bodyObject) {
        return axios.post(`/Api/Admin/Hospitals/Add`, bodyObject);
    },

    GetHospitals(pageNo, pageSize, MunicipalitId) {
        return axios.get(`/Api/Admin/Hospitals/Get?pageno=${pageNo}&pagesize=${pageSize}&MunicipalitId=${MunicipalitId}`);
    },

    EditHospitals(bodyObject) {
        return axios.post(`/Api/Admin/Hospitals/Edit`, bodyObject);
    },

    deleteHospitals(id) {
        return axios.post(`/Api/Admin/Hospitals/${id}/delete`);
    },


    GetDashboardInfo() {
        return axios.get(`/Api/Admin/Hospitals/GetDashboardInfo`);
    },

    GetRequiment() {
        return axios.get(`/Api/Admin/Municipalities/GetRequiment`);
    },



    // **********************************    Municipalities ***********************

    GetAllMunicipalities() {
        return axios.get(`/Api/Admin/Municipalities/GetAll`);
    },

    AddMunicipalities(bodyObject) {
        return axios.post(`/Api/Admin/Municipalities/Add`, bodyObject);
    },

    GetMunicipalities(pageNo, pageSize) {
        return axios.get(`/Api/Admin/Municipalities/Get?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    EditMunicipalities(bodyObject) {
        return axios.post(`/Api/Admin/Municipalities/Edit`, bodyObject);
    },

    DeleteMunicipalities(id) {
        return axios.post(`/Api/Admin/Municipalities/${id}/Delete`);
    },




    // **********************************    GetDevicesName ***********************

    GetDevicesNames() {
        return axios.get(`/Api/Admin/Devices/GetDevicesName`);
    },

    GetDevicesbyCompany(id) {
        return axios.get(`/Api/Admin/Devices/GetDevicesbyCompany?id=${id}`);
    },

    GetFilterNames(id) {
        return axios.get(`/Api/Admin/Devices/GetFilterName?id=${id}`);
    },

    GetAllFilterNames() {
        return axios.get(`/Api/Admin/Devices/GetAllNames`);
    },

    //AddHospitals(bodyObject) {
    //    return axios.post(`/Api/Admin/Devices/Add`, bodyObject);
    //},

    //GetHospitals(pageNo, pageSize, SelectedCityId) {
    //    return axios.get(`/Api/Admin/Devices/GetBranches?pageno=${pageNo}&pagesize=${pageSize}&selectedCityId=${SelectedCityId}`);
    //},

    //EditHospitals(bodyObject) {
    //    return axios.post(`/Api/Admin/Devices/EditBranches`, bodyObject);
    //},

    //deleteHospitals(id) {
    //    return axios.post(`/Api/Admin/Devices/${id}/deleteBranches`);
    //},



}